export default function PageHeader({ eyebrow, title, subtitle, actions }) {
  return (
    <div className="border-b border-canvas-line bg-canvas-card">
      <div className="px-8 py-6 flex items-end justify-between gap-6 flex-wrap">
        <div className="animate-fade-up">
          {eyebrow && (
            <div className="font-mono text-[10px] tracking-[0.3em] uppercase text-ink-muted mb-2">
              {eyebrow}
            </div>
          )}
          <h1 className="font-display text-3xl md:text-4xl font-bold tracking-tight text-ink">
            {title}
          </h1>
          {subtitle && (
            <p className="text-sm text-ink-muted mt-2 max-w-2xl">{subtitle}</p>
          )}
        </div>
        {actions && <div className="flex items-center gap-2">{actions}</div>}
      </div>
    </div>
  );
}
